import type { QueryParams } from '@/types';
const createQueryString = (data: QueryParams): string => {
    const params = new URLSearchParams();

    for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
            const value = data[key];
            if (value != null && value !== '') {
                params.append(key, String(value));
            }
        }
    }

    return `?${params.toString()}`;
};

export default createQueryString;
